<template>
    <div>
        <div class="strategy-item-wrapper" v-if="!showSelect">
            <CoverPanel
                :noCoverIcon="noCoverIcon"
                :imageUrl="data.cardImage"
                :operateIcons="operateIcons"
                :viewIcon="viewIcon"
                @viewClick="viewHandler"
                @uploadCover="uploadCover"
                @operatorSelect="operatorSelect"
            />
            <IconInput class="strategy-item-input" :placeholder="inputDescLabel" :initValue="data.name" @inputChange="descChange" />
            <HotPointPanel :data="hotPointData" @redSwitch="redSwitch" @hotSwitch="hotSwitch" @endDateChange="hotDateChange" v-if="isHlist" />
            <TransferIcon class="opr-transfer" v-show="isHlist" @transfer="tranferItem" />
            <DeleteIcon class="opr-delete" v-show="isHlist" @iconClick="deleteItem" />
        </div>
        <div class="item-selected" @mouseover="onMouseover" @mouseout="onMouseOut" v-else>
            <SelectItem :itemData="itemData" @itemSelect="selectItemType" />
            <DeleteIcon v-show="showDelete && isHlist" class="opr-delete" @iconClick="deleteItemTip" />
        </div>
    </div>
</template>

<script>
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import HotPointPanel from "../HotPointPanel";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";
import SelectItem from "@/views/zhiji/components/coverPanel/SelectItem";

import { isArray, isObject } from "@/views/zhiji/js/common/util.js";

export default {
    name: "StrategyItem",
    props: ["data", "parentUId", "isHlist"],
    components: {
        TransferIcon,
        DeleteIcon,
        IconInput,
        HotPointPanel,
        CoverPanel,
        SelectItem
    },
    data() {
        return {
            showSelect: true,
            viewIcon: {
                position: "-85px -85px"
            },
            showDelete: false
        };
    },
    computed: {
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
        inputDescLabel() {
            return this.$t("zhiji.answer.inputDesc");
        },
        noCoverIcon() {
            return {
                position: "-172px -50px",
                label: this.$t("zhiji.answer.addGuides")
            };
        },
        operateIcons() {
            return [
                {
                    type: "edit",
                    position: "-296px 1px",
                    name: this.$t("zhiji.materialLibrary.editGuides")
                },
                {
                    type: "delete",
                    position: "-96px 0",
                    name: this.$t("zhiji.answer.deleteGuides")
                }
            ];
        },
        itemData() {
            return [
                {
                    type: "reference",
                    position: "-383px -1px",
                    name: this.$t("zhiji.answer.reference"),
                    iconClass: "reference-icon"
                },
                {
                    type: "create",
                    position: "-172px -50px",
                    name: this.$t("zhiji.answer.create")
                }
            ];
        }
    },
    mounted() {
        this.data.resourceId && this.data.cardImage && (this.showSelect = false);
    },
    methods: {
        tranferItem(event) {
            this.zhiji.dragStart(event, "h-list-item", "h", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            newIdx: newIdx,
                            uId: this.data.uId
                        }
                    }
                });
            });
        },
        deleteItem() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.answer.delCardTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.deleteItemHandle();
                    }
                }
            });
        },
        deleteItemTip() {
            this.deleteItemHandle();
            this.$emit("deleteItem");
        },
        deleteItemHandle() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteContentItem",
                widget: {
                    uId: this.parentUId,
                    item: {
                        uId: this.data.uId
                    }
                }
            });
        },
        onMouseover() {
            this.showDelete = true;
        },
        onMouseOut() {
            this.showDelete = false;
        },
        descChange(newVal) {
            this.commitUpdate({
                name: newVal
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState: redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem: hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        viewHandler() {
            this.zhiji
                .requestByServiceName("getVlinkGuidesList", {
                    tipId: this.data.resourceId
                })
                .then(result => {
                    this.$store.dispatch("zhiji/showModal", {
                        type: "GuidesViewModal",
                        data: {
                            name: result.strategyData[0].title,
                            content: result.strategyData[0].content,
                            updateTime: result.strategyData[0].updateTime
                        }
                    });
                });
        },
        uploadCover() {
            this.manualEdit();
        },
        selectItemType(item) {
            let handler = {
                reference: this.referenceEdit,
                create: this.manualEdit
            };
            handler[item.type].call(null);
        },
        operatorSelect(type) {
            if (type === "edit") {
                this.zhiji
                    .requestByServiceName("getVlinkGuidesList", {
                        tipId: this.data.resourceId
                    })
                    .then(result => {
                        this.$store.commit("zhiji/showModal", {
                            type: "TextGuidesEditModel",
                            data: {
                                type: "edit",
                                childModel: true,
                                strategyData: result.strategyData[0],
                                confirm: data => {
                                    this.commitUpdate({
                                        cardImage: data.url,
                                        name: data.title
                                    });
                                }
                            }
                        });
                    });
            }

            if (type === "delete") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.answer.delGuidesTips"),
                        cancel: () => {},
                        confirm: () => {
                            this.commitUpdate({
                                resourceId: "",
                                cardImage: ""
                            });
                            this.showSelect = true;
                        }
                    }
                });
            }
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: this.isHlist ? "updateContentItem" : "updateContent",
                widget: this.isHlist
                    ? {
                          uId: this.parentUId,
                          item: updateData
                      }
                    : updateData
            });
        },
        referenceEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "tip",
                    confirm: result => {
                        let updateData = "";
                        !isArray(result) && isObject(result) ? (updateData = result) : (updateData = result[0]);
                        let addData = isArray(result) && result.slice(1);
                        this.commitUpdate({
                            resourceId: updateData.id,
                            cardImage: updateData.url,
                            name: updateData.title,
                            contentFormat: updateData.contentFormat
                        });
                        isArray(result) && this.addContentItem(addData);

                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        },
        addContentItem(data) {
            data.forEach(item => {
                let curItem = {
                    type: "tip",
                    cardImage: item.url,
                    name: item.title,
                    resourceId: item.id,
                    contentFormat: item.contentFormat
                };
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: this.isHlist ? "addContentItem" : "addContent",
                    widget: this.isHlist
                        ? {
                              uId: this.parentUId,
                              item: {
                                  ...curItem
                              }
                          }
                        : {
                              uId: this.data.uId,
                              ...curItem
                          }
                });
            });
        },
        manualEdit() {
            this.$store.commit("zhiji/showModal", {
                type: "TextGuidesEditModel",
                data: {
                    type: "add",
                    strategyData: {},
                    childModel: true,
                    confirm: data => {
                        this.commitUpdate({
                            resourceId: data.id,
                            cardImage: data.url,
                            name: data.title,
                            contentFormat: data.contentFormat
                        });
                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.strategy-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    flex-shrink: 0;
    width: 200px;

    .opr-transfer {
        display: none;
        top: -21px;
        left: -2px;
        z-index: 1;
        position: absolute;
    }

    .opr-delete {
        display: none;
        right: -9px;
        top: -9px;
        z-index: 1;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
}

.item-selected {
    position: relative;

    .opr-delete {
        position: absolute;
        top: -9px;
        right: 9px;
    }
}
</style>
